const VERSION = "v1";
export const BASE_URL: string =
  process.env.NODE_ENV === "development" ||
  process.env.REACT_APP_HOST_ENV === "development"
    ? `https://dev.goodpharm.kr/api/${VERSION}/partner/`
    : `https://api.goodpharm.kr/api/${VERSION}/partner/`;
